var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('v-alert',{class:_vm.classes,attrs:{"type":_vm.type,"text":_vm.text,"outlined":_vm.outlined,"dense":_vm.dense,"icon":_vm.icon,"dismissible":_vm.dismissible}},[_vm._t("default",function(){return [_vm._v("\n        "+_vm._s(_vm.message)+"\n    ")]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }